export default "__VITE_ASSET__iDj00FuR__"